import { Form } from 'components/collections'
import { Button } from 'components/elements'
import { useSession } from 'context/Session'
import { useRouter } from 'next/router'
import { useSnackbar } from 'notistack'
import * as R from 'ramda'
import { useState } from 'react'

import * as S from './CreateGroupForm.styles'
import { createGroup } from '../../modules/datasource'

const defaultProps = {}
const propTypes = {}

export const CreateGroupForm = () => {
  const router = useRouter()
  const { accessToken } = useSession()
  const { enqueueSnackbar } = useSnackbar()
  const [isFetching, setIsFetching] = useState(false)
  const [groupName, setGroupName] = useState('')
  const [groupDesc, setDescription] = useState('')

  const onSubmit = async values => {
    if (!groupName) {
      enqueueSnackbar('Please enter a group name', { variant: 'error' })
      return
    }
    if (!groupDesc) {
      enqueueSnackbar('Please enter a group description', { variant: 'error' })
      return
    }
    if (!values.autoJoin) {
      enqueueSnackbar('Please select auto join option', { variant: 'error' })
      return
    }
    if ((values.tags || []).length === 0) {
      enqueueSnackbar('Please select at least one tag', { variant: 'error' })
      return
    }

    setIsFetching(true)
    try {
      const { data } = await createGroup({
        values: {
          ...values,
          name: groupName,
          description: groupDesc,
          autoJoin: values?.autoJoin === 'yes',
        },
        accessToken,
      })
      router.push(`/groups/${data.id}`)
    } catch (error) {
      setIsFetching(false)
      enqueueSnackbar(error.response?.data?.message, { variant: 'error' })
    }
  }

  const config = { isFetching, accessToken }

  return (
    <Form
      onSubmit={onSubmit}
      style={{ width: '100%' }}
      initialValues={{
        tags: [],
      }}
    >
      <S.Container>
        <S.FormTitle>Create a Group</S.FormTitle>
        <S.FormHeader>
          <S.NameWrapper>
            <Form.Input
              label="Group Name"
              multiline
              onFocus={e =>
                e.currentTarget.setSelectionRange(
                  e.currentTarget.value.length,
                  e.currentTarget.value.length
                )
              }
              value={groupName}
              onChange={e => setGroupName(e.target.value)}
              autoFocus
              name="name"
            />
          </S.NameWrapper>
          <S.PrivacySelect
            name="autoJoin"
            label="Auto join"
            options={[
              { label: 'Yes', value: 'yes' },
              { label: 'Approval', value: 'invite' },
            ]}
          />
        </S.FormHeader>
        <Form.Input
          label="Description"
          multiline
          minRows={4}
          inputProps={{
            maxLength: 500,
          }}
          onFocus={e =>
            e.currentTarget.setSelectionRange(
              e.currentTarget.value.length,
              e.currentTarget.value.length
            )
          }
          value={groupDesc}
          onChange={e => setDescription(e.target.value)}
          helperText={`${groupDesc.length}/500`}
        />
        <S.Tags {...config} />
        <S.FormSection>
          <S.ImageContainer>
            <Form.Upload
              name="image"
              renderInput={(f = []) => {
                const previewUrl = R.head(f)

                return (
                  <S.ImgPreview
                    src={
                      previewUrl?.preview || (!R.isEmpty(f) && f) || undefined
                    }
                  >
                    {previewUrl ? '' : 'Add image'}
                  </S.ImgPreview>
                )
              }}
            />
            <div>Add an image to your group</div>
          </S.ImageContainer>
        </S.FormSection>
        <S.FormFooter>
          <S.PostButtonContainer>
            <Button
              disabled={isFetching}
              loading={isFetching}
              style={{ width: '100%', maxWidth: '166px' }}
              type="submit"
            >
              Create
            </Button>
            {/* <Button
              disabled={isFetching || isUploading}
              style={{ width: '100%', maxWidth: '166px' }}
              type="button"
              variant="text"
              onClick={() => {
                setDisplayPhoto(R.not)
              }}
            >
              {displayPhoto ? <S.CloseIcon /> : <S.PhotoIcon />} Photo
            </Button> */}
          </S.PostButtonContainer>
        </S.FormFooter>
      </S.Container>
    </Form>
  )
}

CreateGroupForm.defaultProps = defaultProps
CreateGroupForm.propTypes = propTypes

export default CreateGroupForm
